"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FileBookmark: function() {
        return FileBookmark;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FileBookmark = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 4C3 2.34315 4.34315 1 6 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289L20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4ZM6 3C5.44772 3 5 3.44772 5 4V20C5 20.5523 5.44772 21 6 21H18C18.5523 21 19 20.5523 19 20V9H14C13.4477 9 13 8.55228 13 8V3H6ZM15 4.41421L17.5858 7H15V4.41421ZM9 12C9 11.4477 9.44772 11 10 11H14C14.5523 11 15 11.4477 15 12V18C15 18.3597 14.8069 18.6916 14.4942 18.8693C14.1815 19.0471 13.7975 19.0432 13.4885 18.8593L12 17.9732L10.5115 18.8593C10.2025 19.0432 9.81846 19.0471 9.50579 18.8693C9.19313 18.6916 9 18.3597 9 18V12ZM11 13V16.2409L11.4885 15.9501C11.8037 15.7625 12.1963 15.7625 12.5115 15.9501L13 16.2409V13H11Z",
        fill: "currentColor"
    })
}), "FileBookmark");
const _default = FileBookmark;
